"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BsIcon = exports.ICON_VARIANT_DEFAULT = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.ICON_VARIANT_DEFAULT = 'md';
const SVGIcon = styled_components_1.default.svg(({ size, theme }) => (Object.assign({ fill: 'currentColor', display: 'inline-block' }, theme.icons[size || exports.ICON_VARIANT_DEFAULT])));
function BsIcon(props) {
    const { name, className, testId, size } = props, svgProps = __rest(props, ["name", "className", "testId", "size"]);
    return (react_1.default.createElement(SVGIcon, Object.assign({ "data-id": testId }, svgProps, { size: size, className: `bs-icon bs-icon-${name} icon ${className || ''}`.trim() }),
        react_1.default.createElement("use", { href: `#${name}` })));
}
exports.BsIcon = BsIcon;
//# sourceMappingURL=bs-icon.js.map